
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule-tombo-demo",
      function () {
        return require("private-next-pages/schedule-tombo-demo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule-tombo-demo"])
      });
    }
  